import { PREPARATORY_SCHEDULES, StudentServicePath } from "utils/constants";
import { buildFilterQueryString, buildQueryString } from "utils/helpers";

export const studentRequests = {
  // Young children mothers
  setYoungChildrenMother: () => `${StudentServicePath}young-children-mothers/set`,
  unsetYoungChildrenMother: () => `${StudentServicePath}young-children-mothers/unset`,

  // Student records (картон)
  getStudentRecordDetails: studentEducationId =>
    `${StudentServicePath}records/student-educations/${studentEducationId}/student-details`,
  getStudentRecordDisciplines: studentEducationId =>
    `${StudentServicePath}records/student-educations/${studentEducationId}/disciplines`,
  getStudentRecordDisciplineById: (studentEducationId, disciplineId) =>
    `${StudentServicePath}records/student-educations/${studentEducationId}/disciplines/${disciplineId}`,
  getStudentRecordDisciplineByDepartmentId: (studentEducationId, departmentId) =>
    `${StudentServicePath}records/student-educations/${studentEducationId}/disciplines/department/${departmentId}`,
  getStudentRecordContinuingDisciplines: studentEducationId =>
    `${StudentServicePath}records/student-educations/${studentEducationId}/disciplines/continuing`,

  // Class grade
  updateClassGrade: classId => `${StudentServicePath}classes/${classId}/grade`,

  // Mid-semester grades (note: the route segment is `educations`, not `education` like the ones below)
  getMidSemesterGrades: (studentEducationId, disciplineId) =>
    `${StudentServicePath}students/educations/${studentEducationId}/disciplines/${disciplineId}/mid-semester-grades`,
  createMidSemesterGrades: (studentEducationId, disciplineId) =>
    `${StudentServicePath}students/educations/${studentEducationId}/disciplines/${disciplineId}/mid-semester-grades`,
  updateMidSemesterGrade: (studentEducationId, disciplineId, midSemesterGradeId) =>
    `${StudentServicePath}students/educations/${studentEducationId}/disciplines/${disciplineId}/mid-semester-grades/${midSemesterGradeId}`,

  // Individual exams
  createIndividualExam: () => `${StudentServicePath}individual-exams`,
  updateIndividualExam: individualExamId => `${StudentServicePath}individual-exams/${individualExamId}`,

  // Study groups (move / exchange)
  getStudyGroupsSelect: ({
    course,
    instructionLanguageId,
    studyTypeId,
    specialityId,
    showNewGroupOptions,
    excludeGroups,
  } = {}) =>
    `${StudentServicePath}study-groups/select${buildQueryString({
      course,
      instructionLanguageId,
      studyTypeId,
      specialityId,
      showNewGroupOptions,
      ExcludeGroups: excludeGroups,
    })}`,
  moveStudyGroup: () => `${StudentServicePath}study-groups/move`,
  getStudyGroupSwapCandidates: ({ studentEducationId, studyGroup } = {}) =>
    `${StudentServicePath}study-groups/swap${buildQueryString({ studentEducationId, studyGroup })}`,
  swapStudyGroup: () => `${StudentServicePath}study-groups/swap`,
  assignStudentsToStudyGroup: () => `${StudentServicePath}study-groups/students/assign`,

  // Other universities (individual curriculum)
  getOtherUniversityInfo: studentEducationId =>
    `${StudentServicePath}other-universities/student-educations/${studentEducationId}/infos`,
  getOtherUniversityExternalDisciplines: studentEducationId =>
    `${StudentServicePath}other-universities/student-educations/${studentEducationId}/external-disciplines`,
  updateOtherUniversityExternalDisciplines: studentEducationId =>
    `${StudentServicePath}other-universities/student-educations/${studentEducationId}/external-disciplines`,
  getIndividualCurriculum: studentEducationId =>
    `${StudentServicePath}other-universities/student-educations/${studentEducationId}/individual-curriculum`,
  saveIndividualCurriculumDiscipline: (studentEducationId, disciplineId, semester) =>
    `${StudentServicePath}other-universities/student-educations/${studentEducationId}/individual-curriculum/disciplines/${disciplineId}/semesters/${semester}`,
  clearIndividualCurriculumDiscipline: (studentEducationId, disciplineId, semester) =>
    `${StudentServicePath}other-universities/student-educations/${studentEducationId}/individual-curriculum/disciplines/${disciplineId}/semesters/${semester}`,
  saveIndividualCurriculumDisciplineByCourse: (studentEducationId, disciplineId, course) =>
    `${StudentServicePath}other-universities/student-educations/${studentEducationId}/individual-curriculum/disciplines/${disciplineId}/courses/${course}`,
  clearIndividualCurriculumDisciplineByCourse: (studentEducationId, disciplineId, course) =>
    `${StudentServicePath}other-universities/student-educations/${studentEducationId}/individual-curriculum/disciplines/${disciplineId}/courses/${course}`,
  getMakeupGroupContext: (studentEducationId, disciplineId, semester) =>
    `${StudentServicePath}other-universities/student-educations/${studentEducationId}/individual-curriculum/disciplines/${disciplineId}/semesters/${semester}/makeup-group-context`,
  assignMakeupGroup: (studentEducationId, disciplineId, semester) =>
    `${StudentServicePath}other-universities/student-educations/${studentEducationId}/individual-curriculum/disciplines/${disciplineId}/semesters/${semester}/makeup-group`,

  // Student education (by studentEducationId)
  getStudentEducationAttestations: studentEducationId =>
    `${StudentServicePath}students/education/${studentEducationId}/attestations`,
  getStudentEducationAttestationsManagement: studentEducationId =>
    `${StudentServicePath}students/education/${studentEducationId}/attestations/management`,
  updateStudentEducationAttestationsBySemester: (studentEducationId, semester) =>
    `${StudentServicePath}students/education/${studentEducationId}/attestations/semesters/${semester}`,
  getStudentEducationGrades: studentEducationId =>
    `${StudentServicePath}students/education/${studentEducationId}/grades`,
  getStudentPracticeResults: studentEducationId =>
    `${StudentServicePath}students/education/${studentEducationId}/practice-results`,
  saveStudentPracticeResult: (studentEducationId, practiceId, semester) =>
    `${StudentServicePath}students/education/${studentEducationId}/practice-results/practices/${practiceId}/semesters/${semester}`,
  getStudentPracticeResultHistory: (studentEducationId, practiceId, semester) =>
    `${StudentServicePath}students/education/${studentEducationId}/practice-results/practices/${practiceId}/semesters/${semester}/history`,
  getStudentEducationCredits: studentEducationId =>
    `${StudentServicePath}students/education/${studentEducationId}/credits`,
  getStudentEducationDeclarations: studentEducationId =>
    `${StudentServicePath}students/education/${studentEducationId}/declarations`,
  downloadStudentEducationDeclaration: (studentEducationId, declarationId) =>
    `${StudentServicePath}students/education/${studentEducationId}/declarations/${declarationId}/download`,
  getStudentEducationSemesterFees: studentEducationId =>
    `${StudentServicePath}students/education/${studentEducationId}/semester-fees`,
  getStudentStatusHistory: studentEducationId =>
    `${StudentServicePath}students/education/${studentEducationId}/status/history`,
  getStudentAcademicReport: studentEducationId =>
    `${StudentServicePath}students/education/${studentEducationId}/academic-report`,
  postManualAcademicReport: () => `${StudentServicePath}students/education/academic-report/manual`,
  getStudentDisciplineExamGrades: (studentEducationId, disciplineId) =>
    `${StudentServicePath}students/education/${studentEducationId}/discipline/${disciplineId}/exams/grades`,
  getStudentDisciplineGrade: (studentEducationId, disciplineId) =>
    `${StudentServicePath}students/education/${studentEducationId}/disciplines/${disciplineId}`,
  updateStudentDisciplineGrade: (studentEducationId, disciplineId) =>
    `${StudentServicePath}students/education/${studentEducationId}/disciplines/${disciplineId}`,
  getStudentProfilePicture: studentEducationId =>
    `${StudentServicePath}students/education/${studentEducationId}/profile-picture`,
  updateStudentStatus: studentEducationId => `${StudentServicePath}students/education/${studentEducationId}/status`,
  updateStudentCourse: studentEducationId => `${StudentServicePath}students/education/${studentEducationId}/course`,
  updateStudentReceptionType: studentEducationId =>
    `${StudentServicePath}students/education/${studentEducationId}/reception-type`,
  transferStudentFaculty: studentEducationId =>
    `${StudentServicePath}students/education/${studentEducationId}/faculty-transfer`,
  getStudentCurriculumTransferPreview: (studentEducationId, { newCurriculumId } = {}) =>
    `${StudentServicePath}students/education/${studentEducationId}/curriculum-transfer/preview${buildQueryString({
      newCurriculumId,
    })}`,
  transferStudentCurriculum: studentEducationId =>
    `${StudentServicePath}students/education/${studentEducationId}/curriculum-transfer`,
  getStudentsCount: ({ startingYearOnly, specialityId, course, studyGroup } = {}) =>
    `${StudentServicePath}students/education/count${buildQueryString({
      startingYearOnly,
      specialityId,
      course,
      studyGroup,
    })}`,

  // Duplicate check before enrolling: returns the student education(s) matching ALL criteria exactly.
  getStudentEducationExactMatch: ({
    specialityId,
    firstNameEn,
    secondNameEn,
    lastNameEn,
    personId,
    birthCountryId,
    dateOfBirth,
  } = {}) =>
    `${StudentServicePath}students/education/exact-match${buildFilterQueryString({
      SpecialityId: specialityId,
      FirstNameEn: firstNameEn,
      SecondNameEn: secondNameEn,
      LastNameEn: lastNameEn,
      PersonId: personId,
      BirthCountryId: birthCountryId,
      DateOfBirth: dateOfBirth,
    })}`,

  // Student (by studentId)
  updateStudentProfilePicture: studentId => `${StudentServicePath}students/${studentId}/profile-picture`,
  getStudentHealthInsurance: studentId => `${StudentServicePath}students/${studentId}/health-insurance`,
  getStudentIban: studentId => `${StudentServicePath}students/${studentId}/iban`,
  resetStudentGooglePassword: studentId => `${StudentServicePath}students/${studentId}/google-password/reset`,
  updateDormitoryUsage: studentId => `${StudentServicePath}students/${studentId}/dormitory-usage`,
  getStudentHealthCareStatus: studentId => `${StudentServicePath}students/${studentId}/health-care/status`,
  updateStudentHealthCareStatus: studentId => `${StudentServicePath}students/${studentId}/health-care/status`,
  getStudentSportAthleteAchievements: studentId => `${StudentServicePath}students/${studentId}/sport-athletes`,
  createStudentSportAthleteAchievements: studentId => `${StudentServicePath}students/${studentId}/sport-athletes`,
  updateStudentPreferenceAdditionalData: (studentId, preferenceId) =>
    `${StudentServicePath}students/${studentId}/preferences/${preferenceId}/additional-data`,

  getStudentPreviousEducation: studentId => `${StudentServicePath}students/${studentId}/student-previous-educations`,
  updateStudentPreviousEducation: ({ studentId, studentEducationId }) =>
    `${StudentServicePath}students/${studentId}/student-previous-educations/${studentEducationId}`,
  createStudentPreviousEducationDiplomaDocuments: ({ studentId, previousStudentEducationId }) =>
    `${StudentServicePath}students/${studentId}/student-previous-educations/${previousStudentEducationId}/diploma-documents`,
  getStudentPersonalDocuments: studentId => `${StudentServicePath}students/${studentId}/personal-documents`,
  updateStudentPersonalDocuments: ({ studentId, documentId }) =>
    `${StudentServicePath}students/${studentId}/personal-documents/${documentId}`,
  createStudentPersonalDocuments: ({ studentId, documentId }) =>
    `${StudentServicePath}students/${studentId}/personal-documents/${documentId}/documents`,
  deleteStudentPersonalDocuments: ({ studentId, documentId, side }) =>
    `${StudentServicePath}students/${studentId}/personal-documents/${documentId}/documents/${side}`,
  // Preparatory education
  updatePreparatorySpeciality: studentEducationId =>
    `${StudentServicePath}preparatory-educations/${studentEducationId}/specialities`,

  // Academic sessions
  getAcademicSessionsSelect: ({
    onlySessions,
    onlySemesters,
    academicYearId,
    instructionLanguageId,
    structuralUnitId,
    studyTypeId,
  } = {}) =>
    `${StudentServicePath}academic-years/sessions/select${buildQueryString({
      onlySessions,
      onlySemesters,
      academicYearId,
      instructionLanguageId,
      structuralUnitId,
      studyTypeId,
    })}`,
  getAcademicSessionTypesSelect: ({ semestersOnly, studyTypeId } = {}) =>
    `${StudentServicePath}academic-years/sessions/types/select${buildQueryString({ semestersOnly, studyTypeId })}`,
  getAcademicSessionDates: sessionId => `${StudentServicePath}academic-years/sessions/${sessionId}/dates`,
  finalizeAcademicSession: sessionId => `${StudentServicePath}academic-years/sessions/${sessionId}/finalize`,

  // Session exams
  createSessionExam: () => `${StudentServicePath}session-exams`,
  updateSessionExamProfessors: sessionExamId => `${StudentServicePath}session-exams/professors/${sessionExamId}`,
  updateSessionExamIntention: sessionExamId => `${StudentServicePath}session-exams/${sessionExamId}/intention`,
  updateSessionExamStudyGroups: sessionExamId => `${StudentServicePath}session-exams/${sessionExamId}/study-groups`,
  updateSessionExamSlot: sessionExamId => `${StudentServicePath}session-exams/${sessionExamId}/slots`,
  getSessionExamStudents: sessionExamId => `${StudentServicePath}session-exams/${sessionExamId}/students`,
  addStudentsToSessionExam: sessionExamId => `${StudentServicePath}session-exams/${sessionExamId}/students`,
  updateSessionExamGrades: sessionExamId => `${StudentServicePath}session-exams/${sessionExamId}/grades`,
  getGeneralExamProtocol: sessionExamId =>
    `${StudentServicePath}session-exams/general-exam-protocol/${sessionExamId}/generate`,

  // Cyclic streams
  getCyclicStreamSessionDates: (cyclicStreamId, disciplineId) =>
    `${StudentServicePath}cyclic-streams/${cyclicStreamId}/session-dates/${disciplineId}`,
  updateCyclicScheduleStatus: cyclicStreamId => `${StudentServicePath}cyclic-streams/${cyclicStreamId}/status`,
  getCyclicScheduleExpanded: cyclicStreamId => `${StudentServicePath}cyclic-streams/${cyclicStreamId}/expanded`,
  getCyclicScheduleDisciplineProfessors: cyclicDisciplineId =>
    `${StudentServicePath}cyclic-streams/disciplines/${cyclicDisciplineId}/professors`,
  updateCyclicScheduleDisciplineProfessors: cyclicDisciplineId =>
    `${StudentServicePath}cyclic-streams/disciplines/${cyclicDisciplineId}/professors`,

  // Curriculum (topics & exceptions)
  getCurriculumCyclicExamExceptions: curriculumId =>
    `${StudentServicePath}curriculums/${curriculumId}/cyclic-exam-exceptions`,

  updateCurriculumCyclicExamExceptions: curriculumId =>
    `${StudentServicePath}curriculums/${curriculumId}/cyclic-exam-exceptions`,

  getCurriculumCyclicDisciplinesSelect: curriculumId =>
    `${StudentServicePath}curriculums/${curriculumId}/cyclic-disciplines/select`,

  getCurriculumDisciplinesSelect: curriculumId =>
    `${StudentServicePath}curriculums${curriculumId ? `/${curriculumId}` : ""}/disciplines/select`,

  getCurriculumLanguagesSelect: curriculumId => `${StudentServicePath}curriculums/${curriculumId}/languages/select`,

  getCurriculumPracticesSelect: curriculumId => `${StudentServicePath}curriculums/${curriculumId}/practices/select`,

  getCurriculumDisciplineSemestersSelect: (curriculumId, disciplineId) =>
    `${StudentServicePath}curriculums/${curriculumId}/disciplines/${disciplineId}/semesters/select`,

  getCurriculumDisciplineSemesters: (curriculumId, disciplineId) =>
    `${StudentServicePath}curriculums/${curriculumId}/disciplines/${disciplineId}/semesters`,

  getCurriculumDisciplineTopics: (curriculumId, disciplineId, academicYearId, { moduleId } = {}) =>
    `${StudentServicePath}curriculums/${curriculumId}/disciplines/${disciplineId}/academic-years/${academicYearId}/topics${buildQueryString(
      { moduleId },
    )}`,

  updateCurriculumDisciplineTopics: (curriculumId, disciplineId, academicYearId) =>
    `${StudentServicePath}curriculums/${curriculumId}/disciplines/${disciplineId}/academic-years/${academicYearId}/topics`,

  getCurriculumTopicsDisciplineIds: (curriculumId, { academicYearId } = {}) =>
    `${StudentServicePath}curriculums/${curriculumId}/topics/disciplines/ids${buildQueryString({ academicYearId })}`,

  createCurriculumTopic: () => `${StudentServicePath}curriculums/topics`,

  createCurriculumModule: curriculumId => `${StudentServicePath}curriculums/${curriculumId}/modules`,

  updateCurriculumModule: (curriculumId, moduleId) =>
    `${StudentServicePath}curriculums/${curriculumId}/modules/${moduleId}`,

  getCurriculumDisciplineCoursesSelect: (curriculumId, disciplineId) =>
    `${StudentServicePath}curriculums/${curriculumId}/disciplines/${disciplineId}/courses/select`,

  getCurriculumStudyWeeksSelect: curriculumId => `${StudentServicePath}curriculums/${curriculumId}/study-weeks/select`,

  // Curriculum content — one wholesale-replace PUT per collection.
  updateCurriculumDisciplines: curriculumId => `${StudentServicePath}curriculums/${curriculumId}/disciplines`,
  updateCurriculumFacultativeDisciplines: curriculumId =>
    `${StudentServicePath}curriculums/${curriculumId}/facultative-disciplines`,
  updateCurriculumCyclicDisciplines: curriculumId =>
    `${StudentServicePath}curriculums/${curriculumId}/cyclic-disciplines`,
  updateCurriculumElectiveGroups: curriculumId => `${StudentServicePath}curriculums/${curriculumId}/elective-groups`,
  updateCurriculumPractices: curriculumId => `${StudentServicePath}curriculums/${curriculumId}/practices`,
  updateCurriculumInternships: curriculumId => `${StudentServicePath}curriculums/${curriculumId}/internships`,
  updateCurriculumStateExams: curriculumId => `${StudentServicePath}curriculums/${curriculumId}/state-exams`,
  updateCurriculumThesis: curriculumId => `${StudentServicePath}curriculums/${curriculumId}/thesis`,
  updateCurriculumSpecialityAffectedYears: curriculumId =>
    `${StudentServicePath}curriculums/${curriculumId}/speciality-affected-years`,

  // Weekly schedules
  createWeeklySchedule: () => `${StudentServicePath}schedules/weekly`,
  notifyWeeklyScheduleCreation: () => `${StudentServicePath}schedules/weekly/creation-notify`,
  getWeeklyScheduleExpanded: weeklyScheduleId => `${StudentServicePath}schedules/weekly/${weeklyScheduleId}/expanded`,
  updateWeeklyScheduleStatus: weeklyScheduleId => `${StudentServicePath}schedules/weekly/${weeklyScheduleId}/status`,
  getWeeklyScheduleDisciplineForUpdate: (weeklyScheduleId, disciplineId) =>
    `${StudentServicePath}schedules/weekly/${weeklyScheduleId}/disciplines/${disciplineId}/for-update`,
  updateWeeklyScheduleDiscipline: (weeklyScheduleId, disciplineId) =>
    `${StudentServicePath}schedules/weekly/${weeklyScheduleId}/disciplines/${disciplineId}`,
  updateWeeklyScheduleDisciplineProfessors: weeklyScheduleDisciplineId =>
    `${StudentServicePath}schedules/weekly/disciplines/${weeklyScheduleDisciplineId}/professors`,
  updateWeeklyScheduleDisciplineRooms: weeklyScheduleDisciplineId =>
    `${StudentServicePath}schedules/weekly/disciplines/${weeklyScheduleDisciplineId}/rooms`,
  createWeeklyScheduleProfessorSubstitution: weeklyScheduleDisciplineId =>
    `${StudentServicePath}schedules/weekly/disciplines/${weeklyScheduleDisciplineId}/professors/substitutions`,
  getWeeklyTabbedScheduleCalendar: (params = {}) =>
    `${StudentServicePath}schedules/weekly-tabbed/calendar${buildFilterQueryString(params)}`,
  getWeeklyScheduleNonWorkingOccurrences: ({ academicYearSessionId } = {}) =>
    `${StudentServicePath}schedules/weekly/disciplines/non-working-occurrences${buildQueryString({
      academicYearSessionId,
    })}`,
  updateWeeklyScheduleGroupReschedule: groupId =>
    `${StudentServicePath}schedules/weekly/disciplines/groups/${groupId}/reschedules`,

  // Stream weekly schedules
  createStreamWeeklySchedule: () => `${StudentServicePath}schedules/weekly-streams`,
  updateStreamWeeklySchedule: () => `${StudentServicePath}schedules/weekly-streams`,
  getStreamWeeklyScheduleForUpdate: groupId => `${StudentServicePath}schedules/weekly-streams/${groupId}/for-update`,

  // Attestations
  updateAttestationsStatus: () => `${StudentServicePath}attestations/status`,
  getAttestationSpecialitiesSelect: () => `${StudentServicePath}attestations/specialities/select`,
  getAttestationDisciplinesSelect: ({ specialityId } = {}) =>
    `${StudentServicePath}attestations/disciplines/select${buildQueryString({ specialityId })}`,
  getAttestationCoursesSelect: ({ disciplineId, specialityId } = {}) =>
    `${StudentServicePath}attestations/courses/select${buildQueryString({ disciplineId, specialityId })}`,
  getAttestationStudyGroupsSelect: ({ disciplineId, specialityId, course } = {}) =>
    `${StudentServicePath}attestations/study-groups/select${buildQueryString({
      disciplineId,
      specialityId,
      course,
    })}`,

  // Make-ups
  getMakeUpClassesForStudent: (studentEducationId, disciplineId) =>
    `${StudentServicePath}make-ups/students/${studentEducationId}/disciplines/${disciplineId}/classes`,
  markMakeUpMade: () => `${StudentServicePath}make-ups/mark-made`,

  // Classes
  updateClassEquipment: classId => `${StudentServicePath}classes/${classId}/equipment`,
  updateClassAttendance: classId => `${StudentServicePath}classes/${classId}/attendance`,
  getClassAttendanceQrCode: classId => `${StudentServicePath}classes/${classId}/attendance/qr-code`,
  updateClassProfessor: classId => `${StudentServicePath}classes/${classId}/professor`,
  updateClassGrade: classId => `${StudentServicePath}classes/${classId}/grade`,

  // Academic requests
  updateAcademicRequestStatus: academicRequestId =>
    `${StudentServicePath}academic-requests/${academicRequestId}/status`,
  getAcademicRequestDocumentDownload: academicRequestId =>
    `${StudentServicePath}academic-requests/${academicRequestId}/documents/download`,
  getAcademicRequestDataIssueTopicsSelect: () =>
    `${StudentServicePath}nomenclatures/academic-request-data-issue-topics/select`,

  // Nomenclatures (education statuses)
  getEducationStatusesSelect: () => `${StudentServicePath}nomenclatures/education-statuses/select`,
  getEducationStatusReasonsSelect: statusId =>
    `${StudentServicePath}nomenclatures/education-statuses/${statusId}/reasons/select`,

  // Preparatory year schedules (DEOS)
  getPreparatorySchedule: id => `${StudentServicePath}${PREPARATORY_SCHEDULES}/${id}`,
  createPreparatorySchedule: () => `${StudentServicePath}${PREPARATORY_SCHEDULES}`,
  updatePreparatorySchedule: id => `${StudentServicePath}${PREPARATORY_SCHEDULES}/${id}`,
  updatePreparatoryScheduleStatus: id => `${StudentServicePath}${PREPARATORY_SCHEDULES}/${id}/status`,
  getPreparatoryScheduleCurriculum: academicYearId =>
    `${StudentServicePath}${PREPARATORY_SCHEDULES}/academic-years/${academicYearId}/curriculum`,

  //Selects
  getPreparatorySpecialitiesSelect: () => `${StudentServicePath}preparatory-educations/specialities`,
  getDisciplinesSharedSelect: () => `${StudentServicePath}curriculums/disciplines/shared/select`,
  getCurriculumsSelect: ({ specialityId } = {}) =>
    `${StudentServicePath}curriculums/select${buildQueryString({ specialityId })}`,
  getCyclicStreamsSelect: ({ academicYearId, structuralUnitId, instructionLanguageId, course, curriculumId } = {}) =>
    `${StudentServicePath}cyclic-streams/select${buildQueryString({
      academicYearId,
      structuralUnitId,
      instructionLanguageId,
      course,
      curriculumId,
    })}`,
  getCurriculumsDisciplinesSelect: () => `${StudentServicePath}curriculums/disciplines/select`,
  getCurriculumsControlFormsSelect: () => `${StudentServicePath}curriculums/disciplines/control-forms/select`,
  getCurriculumsCurrentSelect: ({ specialityId } = {}) =>
    `${StudentServicePath}curriculums/current${buildQueryString({ specialityId })}`,
  getCurriculumsSpecialitiesSelect: () => `${StudentServicePath}curriculums/specialities/select`,
  getDisciplinesByCyclicStreamIdSelect: cyclicStreamId =>
    `${StudentServicePath}cyclic-streams/${cyclicStreamId}/disciplines/select`,
  getIndividualExamsTypesSelect: () => `${StudentServicePath}individual-exams/types/select`,
  getGradeChangeReasonsSelect: () => `${StudentServicePath}selects/grade-change-reasons`,
  getFacultyNumbersSelect: () => `${StudentServicePath}faculty-numbers/select`,
  getAcademicYearsSelect: () => `${StudentServicePath}academic-years/select`,

  // Curriculum selection campaigns
  startCurriculumSelectionCampaignRanking: campaignId =>
    `${StudentServicePath}curriculum-selection-campaigns/${campaignId}/rank`,
  getCurriculumSelectionCampaignsSelect: () => `${StudentServicePath}curriculum-selection-campaigns/select`,
  getCurriculumSelectionCampaignApplicationById: (campaignId, applicationId) =>
    `${StudentServicePath}curriculum-selection-campaigns/${campaignId}/applications/${applicationId}`,

  // Elective courses
  getElectiveCoursesSelect: () => `${StudentServicePath}elective-courses/select`,
  postElectiveCourseDocument: () => `${StudentServicePath}elective-courses/document`,

  // Curriculum discipline prices (by academic year + speciality)
  getCurriculumDisciplinePrices: (academicYearId, specialityId) =>
    `${StudentServicePath}curriculums/discipline-prices?academicYearId=${academicYearId}&specialityId=${specialityId}`,
  saveRegularDisciplinePrice: (curriculumId, academicYearId, disciplineId, semester) =>
    `${StudentServicePath}curriculums/${curriculumId}/academic-years/${academicYearId}/discipline-prices/disciplines/${disciplineId}/semesters/${semester}`,
  saveFacultativeDisciplinePrice: (curriculumId, academicYearId, disciplineId, semester) =>
    `${StudentServicePath}curriculums/${curriculumId}/academic-years/${academicYearId}/discipline-prices/facultative-disciplines/${disciplineId}/semesters/${semester}`,
  saveCyclicDisciplinePrice: (curriculumId, academicYearId, disciplineId, year) =>
    `${StudentServicePath}curriculums/${curriculumId}/academic-years/${academicYearId}/discipline-prices/cyclic-disciplines/${disciplineId}/years/${year}`,
  saveElectiveGroupPrice: (curriculumId, academicYearId, groupId) =>
    `${StudentServicePath}curriculums/${curriculumId}/academic-years/${academicYearId}/discipline-prices/elective-groups/${groupId}`,
  getCurriculumModulesSelect: curriculumId => `${StudentServicePath}curriculums/${curriculumId}/modules/select`,
  getCurriculumDisciplineModulesSelect: (curriculumId, disciplineId) =>
    `${StudentServicePath}curriculums/${curriculumId}/disciplines/${disciplineId}/modules/select`,
};
